import { Media } from '@/types';

export const isMediaPlayable = ({
  isUserPremium,
  media,
}: {
  isUserPremium: boolean;
  media: Media;
}) => media?.status !== 'comingSoon' && (isUserPremium || media?.isFree);
